import store from '../data/store/store';
import {
    getOptionsForFeature,
    ExternalImagesOptions,
    OwsOptionsFeatureType,
} from 'owa-outlook-service-options';
import { getFallbackValueIfNull } from 'owa-options-core';

/**
 * Utility function which returns the key of currently selected option.
 * Returns fallback value if store value is null
 * Returns store value if not null.
 */
export default function getSelectedOptionKey(): number {
    return getFallbackValueIfNull(
        store().selectedOption as number,
        getOptionsForFeature<ExternalImagesOptions>(OwsOptionsFeatureType.ExternalImages)
            .externalImagesSelectedOption
    );
}
